import Reflux from 'reflux';
import storeUtils from '../../utils/store';
import Cookies from 'js-cookie';
import headerActions from '../../actions/header';

const initialState = {
  // from server
  categories:     {},
  customNavigationItems:     {},
  discover:       {},
  forgotPassword: {},
  language:       {},
  links:          {},
  topLinks:       {},
  login:          {},
  myAccount:      {},
  search:         {},
  suggest:        {},
  translations:   {},
  // state of interface
  loggedUser:  null,
  // hack to force login submission form
  // Note: this is needed for DQS (Dev/Qa/Stage — not Prod) where certificates might be invalid and no certain
  forceSubmit: false,
  // this powers the major categories and the more button
  maxVisibleCategories: 0,
  searchTerm:     '',
  searchResults:  [],
  activeCategory: null,
  panels: {
    top: null,
    mid: null,
    bot: null
  },
  isActiveSlidingPanel: false
};

window.STORES = window.STORES || {};

export default window.STORES.header = class header extends Reflux.Store {

  constructor () {
    super();
    this.state = initialState;
    this.load();

    this.listenTo(headerActions.search, 'searchStart');
    this.listenTo(headerActions.search.completed, 'searchCompleted');
    this.listenTo(headerActions.clearSearch, 'clearSearch');
    this.listenTo(headerActions.toggleCategory, 'toggleCategory');
    this.listenTo(headerActions.toggleMidPanel, 'toggleMidPanel');
    this.listenTo(headerActions.toggleTopPanel, 'toggleTopPanel');
    this.listenTo(headerActions.toggleMaxVisibleCategories, 'toggleMaxVisibleCategories');
    this.listenTo(headerActions.toggleSlidingPanel, 'toggleSlidingPanel');
  }

  load () {
    var headerData = storeUtils.get('header');
    if (headerData instanceof Error) return;

    const data = {
      categories: headerData.header.categories,
      customNavigationItems: headerData.header.customNavigationItems,
      discover: headerData.header.discover,
      language: headerData.header.language,
      links: headerData.header.links,
      topLinks: headerData.header.topLinks,
      myAccount: headerData.header.myAccount,
      search: headerData.header.search,
      suggest: headerData.header.suggest,
      logo: headerData.header.logo
    };

    try {
      if (Cookies.get('userinfo')) {
        data.loggedUser = JSON.parse(decodeURIComponent(Cookies.get('userinfo')));
      }
    }
    catch (e) {
      console.warn(Cookies.get('userinfo'), 'error parsing userinfo cookie', e);
    }

    this.setState(data);
  }

  toggleMaxVisibleCategories (maxNum, hasMore) {
    const changes = {};
    changes.maxVisibleCategories = maxNum;

    // FIXME, a bit hacky, when cleaning up fix this code
    // if the category panel is open and the active category is more, close the panel
    if (this.state.activeCategory === 'more' && !hasMore) {
      changes.activeCategory = null;

      if (this.state.panels.mid === 'category') {
        changes.panels = {...this.state.panels, mid: null};
      }

      if (this.state.panels.bot === 'category') {
        changes.panels = {...this.state.panels, bot: null};
      }
    }
    this.setState(changes);
  }

  clearSearch () {
    this.setState({ searchTerm: '', searchResults: [] });
  }

  toggleCategory (type, panel) {
    if (this.state.activeCategory === type) {
      this.setState({
        activeCategory: null,
        panels: {...this.state.panels, [panel]: null }
      });
    }
    else {
      this.resetPanels(true);
      this.setState({
        activeCategory: type,
        panels: {...this.state.panels, [panel]: 'category' }
      });
    }
  }

  toggleMajorCategory (type) {
    if (this.state.activeCategory === type) {
      this.setState({
        activeCategory: null,
        panels: {...this.state.panels, bot: null }
      });
    }
    else {
      this.resetPanels(true);
      this.setState({
        activeCategory: type,
        panels: {...this.state.panels, bot: 'category' }
      });
    }
  }

  toggleMidPanel (type) {
    if (this.state.panels.mid === type) {
      this.setState({
        panels: {...this.state.panels, mid: null }
      });
    }
    else {
      this.resetPanels(true);
      this.setState({
        panels: {...this.state.panels, mid: type }
      });
    }
  }

  toggleTopPanel (type) {
    if (this.state.panels.top === type) {
      this.setState({
        panels: {...this.state.panels, top: null }
      });
    }
    else {
      this.resetPanels(true);
      this.setState({
        panels: {...this.state.panels, top: type }
      });
    }
  }

  searchStart (url, searchTerm, closeOtherPanels) {
    const changes = {};
    changes.searchTerm = searchTerm;
    if (!searchTerm) {
      changes.searchResults = [];
    }
    this.setState(changes);
    if (closeOtherPanels) {
      this.resetPanels(false);
    }
  }

  searchCompleted (response) {
    const searchTerm = this.state.searchTerm.toLowerCase().trim().replace(/\s\s+/g, ' ');
    if (searchTerm === response.body.search) {
      this.setState({searchResults: response.body.data});
    }
  }

  resetPanels (resetSearch) {
    const changes = {};
    if (resetSearch) {
      changes.searchTerm = '';
      changes.searchResults = [];
    }
    changes.activeCategory = null;
    changes.panels = { top: null, mid: null, bot: null };
    this.setState(changes);
  }

  toggleSlidingPanel () {
    const isActive = !this.state.isActiveSlidingPanel;
    this.setState({isActiveSlidingPanel: isActive});
  }
};



// WEBPACK FOOTER //
// ./frontend/react/stores/header/index.js